module.exports = __webpack_public_path__ + "3c53ced7dfa891a60fc2f3cc761106f8.jpg";